import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ColorCustomizer from "@/components/ColorCustomizer";
import JivoInjector from "@/components/site/JivoInjector";
import Maintenance from "@/pages/Maintenance";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";

export default function SiteLayout() {
  const { settings } = useSettings();
  const { user } = useAuth();

  if (settings?.maintenance_enabled && !user) {
    return <Maintenance settings={settings} />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {settings?.maintenance_enabled && user && (
        <div className="bg-amber-500 text-white text-center text-sm py-2 font-medium" data-testid="maintenance-admin-banner">
          Режим обслуживания включён — сайт виден только вам (администратору)
        </div>
      )}
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ColorCustomizer />
      <JivoInjector />
    </div>
  );
}
